import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectFromDualListComponent } from './select-from-dual-list.component';
import {MatTableModule} from '@angular/material/table';
import {InfraModule} from 'ac-infra';
import {MaterialModule} from '../../material.module';

@NgModule({
  declarations: [
    SelectFromDualListComponent
  ],
  exports: [
    SelectFromDualListComponent
  ],
  imports: [
    CommonModule,
    InfraModule,
    MatTableModule,
    MaterialModule
  ]
})
export class SelectFromDualListModule { }
